/**
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 */
export enum Orientation {
    Horizontal= 'horizontal',
    Vertical= 'vertical',
  };

export enum PanePriority {
    Pane1 = 'pane1',
    Pane2 = 'pane2',
  };

export enum PaneMode {
    Auto = 'Auto',
    Single = 'Single',
    Double = 'Double',
  };
